import React from "react";

import { RushaSvgIcon } from "./RushaSvgIcon";

/**
 * Organization icon — building shape.
 *
 * Dual-tone layered style:
 * - Building outline (rounded rect body with a roof line) in currentColor
 * - Cyan accent fill at 10% opacity on the main body
 * - No node dots
 */
export const OrganizationIcon: React.FC<{ size?: number }> = ({
  size = 24,
}) => (
  <RushaSvgIcon size={size}>
    {/* Accent fill on the main building body */}
    <rect
      x="5"
      y="7"
      width="14"
      height="13"
      rx="2"
      fill="#00d4ff"
      fillOpacity={0.1}
    />
    {/* Roof line */}
    <path
      d="M4 7 L12 3 L20 7"
      fill="none"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    {/* Building body outline */}
    <rect
      x="5"
      y="7"
      width="14"
      height="13"
      rx="2"
      fill="none"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    {/* Door */}
    <path
      d="M10 20 L10 15 L14 15 L14 20"
      fill="none"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </RushaSvgIcon>
);

OrganizationIcon.displayName = "OrganizationIcon";

export default OrganizationIcon;
